import React, { useContext } from "react";
import classnames from "classnames";
import { Drawer, Icon, Wrapper } from "@/components";
import { i18n, priceFormat } from "@/utils";
import { IUpgradeVersionData } from "../../new-sock";
import { ProductContext } from "../../";
import styles from "./style.less";

interface relatedProductProps {
  /** vip 增值服务 */
  data: IUpgradeVersionData;
  /** 关闭回调 */
  onClose(): void;
  /** 确认回调 */
  onConfirm: () => void;
  /** 不需要回调 */
  onCancel: () => void;
}

const relatedProduct: React.FC<relatedProductProps> = ({
  data,
  onClose,
  onConfirm,
  onCancel,
}) => {
  const { shop } = useContext(ProductContext);

  return (
    <Wrapper className={styles.upgradeWrapper}>
      <Drawer duration={0.3} mask className={styles.upgradeDrawer}>
        <div className={styles.upgrade}>
          <div className={styles.closeWrapper} onClick={onClose}>
            <Icon type="down" size={20} />
          </div>
          <div className={styles.content}>
            <div className={styles.title}>
              {i18n.format("modules.new.sock.upgrade.version.title")}
            </div>
            <p className={styles.contentDesc}>
              {i18n.format("modules.new.sock.upgrade.version.desc")}
            </p>
            <div className={styles.imgContent}>
              <img src={data.url} alt="product preview" />
              {data.originPrice && data.originPrice !== data.price && (
                <div className={styles.off}>
                  {`${
                    Math.round((1 - data.price / data.originPrice) * 10000) /
                    100
                  }%${i18n.format("modules.new.sock.upgrade.off")}`}
                </div>
              )}
            </div>
            <p className={styles.prodcutTitle}>{data.title}</p>
            <div className={styles.priceWrapper}>
              <span className={classnames(styles.price, styles.priceActive)}>
                {`+ ${priceFormat(shop.currencySymbol, data.price)}`}
              </span>
              {data.originPrice && data.originPrice !== data.price && (
                <span className={styles.price}>
                  {priceFormat(shop.currencySymbol, data.originPrice)}
                </span>
              )}
            </div>
          </div>
          <div className={styles.footer}>
            <button
              type="button"
              className={styles.button}
              onClick={() => onConfirm()}
            >
              {i18n.format("modules.new.sock.upgrade.save")}
            </button>
            <button
              type="button"
              className={classnames(styles.button, styles.cancelButton)}
              onClick={() => onCancel()}
            >
              {i18n.format("modules.new.sock.upgrade.next")}
            </button>
          </div>
        </div>
      </Drawer>
    </Wrapper>
  );
};

export default relatedProduct;
